import { CFD_POS_PAYMENT_FLOWS, USER_PROGRESS } from "../../VNCustomerFacingDisplay/Enums"
import { getCurrentPaymentFlow } from "../../VNCustomerFacingDisplay/Selectors"
import { setCardAuthStepOne, setCardAuthStepTwo, setConfirmPaymentDialog, setCustomerPayingWithCard, setCustomerViewingReceiptDialog, setGenericDialog, setGenericDialogData, setOpenCustomerEnteringTipDialog, setTransactionCompleteDialog, setTransactionErrorDialog } from "../../VNDialogs/ActionCreators"
import { MODES } from "../../VNMode/Reducer"
import { getDeviceMode } from "../../VNMode/Selectors"
import * as VNCFD_ActionTypes from '../../VNCustomerFacingDisplay/ActionTypes'
import { updateSavedPayment } from "../../actions/order"

const TRANSACTION_ERROR_DELAY = 3000

export const userPaymentProgressHandler = (state, dispatch, data) => {
  const currentPaymentFlow = getCurrentPaymentFlow(state)
  const deviceMode = getDeviceMode(state)

  if (data.flow === 'VIEWING_RECEIPT' && currentPaymentFlow !== CFD_POS_PAYMENT_FLOWS.UNSET && data.freeItem === "true") {
    dispatch(setOpenCustomerEnteringTipDialog({open: false}))
    dispatch(setConfirmPaymentDialog(false))
    dispatch(setCustomerViewingReceiptDialog(true))
    dispatch(setTransactionCompleteDialog(false))
  }

  if (data.flow === 'VIEWING_RECEIPT' && data?.tabbed === "true") {
    dispatch(updateSavedPayment({tipAmountInCents: parseInt(data.tipInCents ?? 0)}))
    dispatch(setOpenCustomerEnteringTipDialog({open: false}))
    dispatch(setConfirmPaymentDialog(false))
    dispatch(setCustomerViewingReceiptDialog(true))
    dispatch(setTransactionCompleteDialog(false))
  }

  if (currentPaymentFlow === CFD_POS_PAYMENT_FLOWS.QR_PAY ||
    currentPaymentFlow === CFD_POS_PAYMENT_FLOWS.GIFT_CARD ||
    currentPaymentFlow === CFD_POS_PAYMENT_FLOWS.TICKET) {
    if (data.flow === 'TRANSACTION_COMPLETE') {
        dispatch(setCustomerViewingReceiptDialog(false))
        dispatch(setTransactionCompleteDialog(true))
    } else if (data.flow === 'TRANSACTION_ERROR') {
      setTimeout(() => {
        dispatch(setCustomerPayingWithCard({open: false}))
        dispatch(setTransactionErrorDialog({ open: true, subTitle: data.subTitle }))
      }, TRANSACTION_ERROR_DELAY);
      return
    }
  } else if (deviceMode === MODES.POS && currentPaymentFlow === CFD_POS_PAYMENT_FLOWS.SPLIT_PAY) {
    if (data.flow === 'TRANSACTION_ERROR') {
      setTimeout(() => {
        dispatch(setCustomerPayingWithCard({open: false}))
        dispatch(setTransactionErrorDialog({ open: true, subTitle: data.subTitle }))
      }, TRANSACTION_ERROR_DELAY);
      return
    }
  }

  switch (data.title) {
    case USER_PROGRESS.CARD_PAYMENT.AUTHORIZED_CARD.title:
      setCardAuthStepTwo({open: true, amount: data.amount})
      setCardAuthStepOne({open: false})
      break;
  
    default:
      break;
  }

  dispatch({
    type: VNCFD_ActionTypes.VNCFD_USER_PAYMENT_PROGRESS,
    data: data
  })
}